export default {
  setMolduras(state, { molduras, totemId }) {
    state.molduras = Array.isArray(molduras) ? molduras : [];
    state.totemId = totemId || null;
    state.carregado = true;
  },
};
